import { render, staticRenderFns } from "./responsivefooter.html?vue&type=template&id=21f22498&scoped=true&"
import script from "./responsivefooter.js?vue&type=script&lang=js&"
export * from "./responsivefooter.js?vue&type=script&lang=js&"
import style0 from "./responsivefooter.scss?vue&type=style&index=0&id=21f22498&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f22498",
  null
  
)

export default component.exports